import { number, oneOf, string } from 'prop-types';
import classnames from 'classnames';
import React, { Fragment } from 'react';
import CONFIGS from './configs';

function ImagePlaceholder(props) {
  const { aspectRatio, cssHook, placement } = props;

  const placeholderClasses = classnames('Placeholder', {
    [`${cssHook}__placeholder`]: cssHook
  });

  const placeholderConfig = CONFIGS[placement];

  const placeholderAspectRatio = aspectRatio || 3 / 2;

  return (
    <Fragment>
      {placeholderConfig.map(({ media, isResponsive, maxWidth, maxHeight }) => {
        if (isResponsive) {
          return (
            <div key={media} className={placeholderClasses}>
              <style jsx>{`
                .Placeholder {
                  display: none;
                }
                @media ${media || '(min-width: 0px)'} {
                  .Placeholder {
                    display: block;
                    width: 100%;
                    height: 0;
                    padding-top: ${100 / placeholderAspectRatio}%;
                    background-color: #fff;
                  }
                }
              `}</style>
            </div>
          );
        }
        return (
          <div key={media} className={placeholderClasses}>
            <style jsx>{`
              .Placeholder {
                display: none;
              }
              @media ${media || '(min-width: 0px)'} {
                .Placeholder {
                  display: block;
                  width: ${maxWidth}px;
                  max-width: ${maxHeight
                    ? `${maxHeight * placeholderAspectRatio}px`
                    : 'none'};
                  height: ${maxWidth / placeholderAspectRatio}px;
                  max-height: ${maxHeight ? `${maxHeight}px` : 'none'};
                  background-color: #fff;
                }
              }
            `}</style>
          </div>
        );
      })}
    </Fragment>
  );
}

ImagePlaceholder.defaultProps = {
  aspectRatio: undefined,
  cssHook: undefined
};

ImagePlaceholder.propTypes = {
  aspectRatio: number,
  cssHook: string,
  placement: oneOf([
    'cover',
    'faqItem',
    'faqPage',
    'featuredEmailList',
    'inPost',
    'interrupter',
    'prism',
    'product',
    'responsive',
    'sliderGallery',
    'sideBySide'
  ]).isRequired
};

export default ImagePlaceholder;
